"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultInputAdapter = void 0;
class DefaultInputAdapter {
    normalizePoints(rawPoints) {
        return rawPoints.map(p => ({
            x: p.x,
            y: p.y,
            pressure: p.pressure ?? 1,
            timestamp: p.timestamp ?? Date.now()
        }));
    }
    /**
     * Smoothes a stroke using Catmull-Rom spline interpolation.
     * This helps low-sampling-rate devices look fluid.
     */
    smoothStroke(stroke) {
        if (!stroke.points || stroke.points.length < 3)
            return stroke;
        const smoothedPoints = [];
        const pts = stroke.points;
        // Catmull-Rom implementation with proper bounds checking
        for (let i = 0; i < pts.length - 1; i++) {
            const p0 = pts[Math.max(0, i - 1)];
            const p1 = pts[i];
            const p2 = pts[i + 1];
            const p3 = pts[Math.min(pts.length - 1, i + 2)];
            for (let t = 0; t < 1; t += 0.25) { // 4 segments per point pair
                const t2 = t * t;
                const t3 = t2 * t;
                const x = 0.5 * ((2 * p1.x) +
                    (-p0.x + p2.x) * t +
                    (2 * p0.x - 5 * p1.x + 4 * p2.x - p3.x) * t2 +
                    (-p0.x + 3 * p1.x - 3 * p2.x + p3.x) * t3);
                const y = 0.5 * ((2 * p1.y) +
                    (-p0.y + p2.y) * t +
                    (2 * p0.y - 5 * p1.y + 4 * p2.y - p3.y) * t2 +
                    (-p0.y + 3 * p1.y - 3 * p2.y + p3.y) * t3);
                const pressure = p1.pressure + (p2.pressure - p1.pressure) * t;
                smoothedPoints.push({
                    x,
                    y,
                    pressure,
                    timestamp: p1.timestamp + (p2.timestamp - p1.timestamp) * t
                });
            }
        }
        // Add final point
        smoothedPoints.push(pts[pts.length - 1]);
        return {
            ...stroke,
            points: smoothedPoints
        };
    }
}
exports.DefaultInputAdapter = DefaultInputAdapter;
